import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
} from 'react';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext<{
  isAuthenticated: boolean;
  loading: boolean;
}>({
  isAuthenticated: false,
  loading: true,
});

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const hasRestoredPath = useRef(false);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/dashboard-auth`, {
      credentials: 'include',
    })
      .then(async (res) => {
        const data = await res.json();

        if (data.code === 200) {
          setIsAuthenticated(true);

          // Only handle redirect once
          if (!hasRestoredPath.current) {
            hasRestoredPath.current = true;

            // Check if there's a stored redirect path after OAuth authentication
            const redirectPath = sessionStorage.getItem('redirectAfterAuth');

            if (redirectPath) {
              sessionStorage.removeItem('redirectAfterAuth');
              navigate(redirectPath, { replace: true });
            }
          }
        }
      })
      .catch(() => setIsAuthenticated(false))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
